import React from 'react';
import usePresence from '../../use/usePresence';

interface CarregandoProps {
  /** Enquanto verdadeiro, mostra o esqueleto. */
  quando: boolean;
  /** O esqueleto com a forma do conteúdo que vem depois. */
  esqueleto: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/**
 * A troca esqueleto → conteúdo, com cross-fade.
 *
 * Antes toda tela fazia `if (loading) return <Skeleton/>` ou o par
 * `{loading && <Skeleton/>}` + `{!loading && <Conteúdo/>}`. Nos dois casos a
 * troca acontece no MESMO frame: o esqueleto some e o conteúdo aparece pronto.
 *
 * Sobrepor os dois é a única forma de cross-fade — irmãos que desmontam não
 * ocupam o mesmo espaço, e conteúdo entrando de `opacity: 0` sobre um esqueleto
 * já removido pisca o fundo por um frame. Então o conteúdo entra no fluxo (é ele
 * que define a caixa) e o esqueleto, na saída, vira `absolute inset-0` por cima.
 *
 * A entrada do conteúdo é só opacidade, de propósito: cross-fade é isso. Quem tem
 * lista dentro já ganha deslocamento e desfoque item a item pelo `.stagger`, e as
 * duas coisas juntas empilhariam duas animações no mesmo pixel.
 */
export default function Carregando({ quando, esqueleto, children, className = '' }: CarregandoProps) {
  const { montado, estado } = usePresence(quando, 180);

  return (
    <div className={`relative ${className}`}>
      {!quando && <div className="animate-fade-in">{children}</div>}

      {montado && (
        <div
          data-state={estado}
          className={`data-[state=closed]:animate-fade-out ${quando ? '' : 'absolute inset-0 pointer-events-none'}`}
        >
          {esqueleto}
        </div>
      )}
    </div>
  );
}
